// Auto-generated from GCP top100 resources whitelist
export const gcpIconsByTypeTop100: Record<string, string> = {
  // Compute
  google_compute_instance: "/icons/gcp/compute_engine.svg",
  google_compute_instance_template: "/icons/gcp/compute_engine.svg",
  google_compute_instance_group: "/icons/gcp/compute_engine.svg",
  google_compute_instance_group_manager: "/icons/gcp/compute_engine.svg",
  google_compute_autoscaler: "/icons/gcp/compute_engine.svg",
  google_compute_disk: "/icons/gcp/persistent_disk.svg",
  google_compute_snapshot: "/icons/gcp/persistent_disk.svg",
  google_compute_image: "/icons/gcp/compute_engine.svg",
  google_container_cluster: "/icons/gcp/google_kubernetes_engine.svg",
  google_container_node_pool: "/icons/gcp/google_kubernetes_engine.svg",
  google_cloudfunctions_function: "/icons/gcp/cloud_functions.svg",
  google_cloudfunctions2_function: "/icons/gcp/cloud_functions.svg",
  google_cloud_run_service: "/icons/gcp/cloud_run.svg",
  google_cloud_run_v2_service: "/icons/gcp/cloud_run.svg",
  google_app_engine_application: "/icons/gcp/app_engine.svg",
  google_app_engine_standard_app_version: "/icons/gcp/app_engine.svg",

  // Storage
  google_storage_bucket: "/icons/gcp/cloud_storage.svg",
  google_storage_bucket_object: "/icons/gcp/cloud_storage.svg",
  google_storage_bucket_iam_member: "/icons/gcp/cloud_storage.svg",
  google_storage_bucket_iam_policy: "/icons/gcp/cloud_storage.svg",
  google_filestore_instance: "/icons/gcp/filestore.svg",
  google_compute_resource_policy: "/icons/gcp/compute_engine.svg",

  // Database
  google_sql_database_instance: "/icons/gcp/cloud_sql.svg",
  google_sql_database: "/icons/gcp/cloud_sql.svg",
  google_sql_user: "/icons/gcp/cloud_sql.svg",
  google_bigtable_instance: "/icons/gcp/bigtable.svg",
  google_bigtable_table: "/icons/gcp/bigtable.svg",
  google_spanner_instance: "/icons/gcp/cloud_spanner.svg",
  google_spanner_database: "/icons/gcp/cloud_spanner.svg",
  google_firestore_database: "/icons/gcp/firestore.svg",
  google_firestore_document: "/icons/gcp/firestore.svg",
  google_redis_instance: "/icons/gcp/memorystore.svg",
  google_memcache_instance: "/icons/gcp/memorystore.svg",

  // Networking
  google_compute_network: "/icons/gcp/virtual_private_cloud.svg",
  google_compute_subnetwork: "/icons/gcp/virtual_private_cloud.svg",
  google_compute_firewall: "/icons/gcp/cloud_firewall_rules.svg",
  google_compute_router: "/icons/gcp/cloud_router.svg",
  google_compute_router_nat: "/icons/gcp/cloud_nat.svg",
  google_compute_vpn_gateway: "/icons/gcp/cloud_vpn.svg",
  google_compute_vpn_tunnel: "/icons/gcp/cloud_vpn.svg",
  google_compute_address: "/icons/gcp/cloud_external_ip_addresses.svg",
  google_compute_global_address: "/icons/gcp/cloud_external_ip_addresses.svg",
  google_compute_forwarding_rule: "/icons/gcp/cloud_load_balancing.svg",
  google_compute_global_forwarding_rule: "/icons/gcp/cloud_load_balancing.svg",
  google_compute_backend_service: "/icons/gcp/cloud_load_balancing.svg",
  google_compute_backend_bucket: "/icons/gcp/cloud_load_balancing.svg",
  google_compute_health_check: "/icons/gcp/cloud_load_balancing.svg",
  google_compute_http_health_check: "/icons/gcp/cloud_load_balancing.svg",
  google_compute_https_health_check: "/icons/gcp/cloud_load_balancing.svg",
  google_compute_url_map: "/icons/gcp/cloud_load_balancing.svg",
  google_compute_target_http_proxy: "/icons/gcp/cloud_load_balancing.svg",
  google_compute_target_https_proxy: "/icons/gcp/cloud_load_balancing.svg",
  google_compute_ssl_certificate: "/icons/gcp/certificate_manager.svg",
  google_compute_managed_ssl_certificate: "/icons/gcp/certificate_manager.svg",
  google_dns_managed_zone: "/icons/gcp/cloud_dns.svg",
  google_dns_record_set: "/icons/gcp/cloud_dns.svg",
  google_compute_interconnect_attachment: "/icons/gcp/cloud_interconnect.svg",
  google_compute_network_peering: "/icons/gcp/virtual_private_cloud.svg",
  google_compute_route: "/icons/gcp/cloud_routes.svg",
  google_compute_security_policy: "/icons/gcp/cloud_armor.svg",
  google_network_connectivity_hub: "/icons/gcp/network_connectivity_center.svg",

  // Security
  google_project_iam_member: "/icons/gcp/identity_and_access_management.svg",
  google_project_iam_binding: "/icons/gcp/identity_and_access_management.svg",
  google_project_iam_policy: "/icons/gcp/identity_and_access_management.svg",
  google_service_account: "/icons/gcp/identity_and_access_management.svg",
  google_service_account_key: "/icons/gcp/identity_and_access_management.svg",
  google_service_account_iam_member: "/icons/gcp/identity_and_access_management.svg",
  google_kms_key_ring: "/icons/gcp/key_management_service.svg",
  google_kms_crypto_key: "/icons/gcp/key_management_service.svg",
  google_kms_crypto_key_iam_member: "/icons/gcp/key_management_service.svg",
  google_secret_manager_secret: "/icons/gcp/secret_manager.svg",
  google_secret_manager_secret_version: "/icons/gcp/secret_manager.svg",
  google_compute_ssl_policy: "/icons/gcp/certificate_manager.svg",
  google_iap_web_iam_member: "/icons/gcp/identity-aware_proxy.svg",
  google_identity_platform_config: "/icons/gcp/identity_platform.svg",

  // Analytics
  google_bigquery_dataset: "/icons/gcp/bigquery.svg",
  google_bigquery_table: "/icons/gcp/bigquery.svg",
  google_bigquery_job: "/icons/gcp/bigquery.svg",
  google_dataflow_job: "/icons/gcp/dataflow.svg",
  google_dataproc_cluster: "/icons/gcp/dataproc.svg",
  google_pubsub_topic: "/icons/gcp/pubsub.svg",
  google_pubsub_subscription: "/icons/gcp/pubsub.svg",
  google_composer_environment: "/icons/gcp/cloud_composer.svg",
  google_data_fusion_instance: "/icons/gcp/cloud_data_fusion.svg",
  google_datastream_stream: "/icons/gcp/datastream.svg",

  // DevOps
  google_cloudbuild_trigger: "/icons/gcp/cloud_build.svg",
  google_artifact_registry_repository: "/icons/gcp/artifact_registry.svg",
  google_container_registry: "/icons/gcp/container_registry.svg",
  google_sourcerepo_repository: "/icons/gcp/compute_engine.svg",
  google_clouddeploy_delivery_pipeline: "/icons/gcp/cloud_deploy.svg",

  // Monitoring
  google_logging_project_sink: "/icons/gcp/cloud_logging.svg",
  google_logging_folder_sink: "/icons/gcp/cloud_logging.svg",
  google_logging_organization_sink: "/icons/gcp/cloud_logging.svg",
  google_monitoring_alert_policy: "/icons/gcp/cloud_monitoring.svg",
  google_monitoring_notification_channel: "/icons/gcp/cloud_monitoring.svg",
  google_monitoring_dashboard: "/icons/gcp/cloud_monitoring.svg",
  google_monitoring_uptime_check_config: "/icons/gcp/cloud_monitoring.svg",

  // AI/ML
  google_vertex_ai_dataset: "/icons/gcp/vertexai.svg",
  google_vertex_ai_endpoint: "/icons/gcp/vertexai.svg",
  google_vertex_ai_featurestore: "/icons/gcp/vertexai.svg",
  google_notebooks_instance: "/icons/gcp/ai_platform.svg",
  google_ml_engine_model: "/icons/gcp/ai_platform.svg",

  // Management
  google_project: "/icons/gcp/project.svg",
  google_folder: "/icons/gcp/project.svg",
  google_organization_policy: "/icons/gcp/administration.svg",
  google_project_service: "/icons/gcp/cloud_apis.svg",
  google_resource_manager_lien: "/icons/gcp/administration.svg",

  // Billing
  google_billing_account_iam_member: "/icons/gcp/billing.svg",
  google_billing_budget: "/icons/gcp/billing.svg",

  // Other
  google_compute_project_metadata: "/icons/gcp/compute_engine.svg",
  google_compute_project_metadata_item: "/icons/gcp/compute_engine.svg",
  google_apikeys_key: "/icons/gcp/cloud_apis.svg",
  google_vpc_access_connector: "/icons/gcp/virtual_private_cloud.svg",
  google_endpoints_service: "/icons/gcp/cloud_endpoints.svg",
  google_compute_region_backend_service: "/icons/gcp/cloud_load_balancing.svg",
  google_compute_target_pool: "/icons/gcp/cloud_load_balancing.svg",
  google_compute_instance_iam_member: "/icons/gcp/identity_and_access_management.svg",
  google_folder_iam_member: "/icons/gcp/identity_and_access_management.svg",
  google_organization_iam_member: "/icons/gcp/identity_and_access_management.svg",
};
